<template>
    <div>
        <h1 class="display-heading">Company Credit Balance</h1>

        <div v-for="(companyBenefit, index) in companyBenefits" :key="index" class="card mb-5">
            <div class="card-body">
                            <div class="row ml-3 mr-3 mb-3">
                                <div class="col col-4">
                                    <h5 class="card-title">Company Name</h5>
                                    <div class="ewallet-display">{{companyBenefit.companyName}}</div>
                                </div>
                                <div class="col col-4">
                                    <h5 class="card-title">Principal Name</h5>
                                    <div class="ewallet-display">{{companyBenefit.principalName}}</div>
                                </div>
                                <div class="col col-4">
                                    <button class="float-right btn btn-primary btn-primary-insv mr-2" type="button" @click="openCoverage(index)">View Benefits Coverage</button>
                                </div>
                            </div>
                <table class="table mb-0">
                    <colgroup>
                        <col>
                        <col width="220">
                        <col v-if="companyBenefit.spouseBenefit" width="220">
                        <col v-if="companyBenefit.dependentBenefit" width="220">
                    </colgroup>
                    <thead>
                        <tr class="text-right">
                            <th></th>
                            <th>
                                Benefit Type - {{companyBenefit.benefitType}}
                            </th>
                            <th v-if="companyBenefit.spouseBenefit">
                                Benefit Type - Spouse
                            </th>
                            <th v-if="companyBenefit.dependentBenefit">
                                Benefit Type - Dependent
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><b>Annual Aggregated Usage (RM)</b></td>
                            <td class="text-right">
                                {{companyBenefit.companyAnnualUsage.toFixed(2)}}
                            </td>
                            <td v-if="companyBenefit.spouseBenefit" class="text-right">
                                {{companyBenefit.spouseAnnualUsage.toFixed(2)}}
                            </td>
                            <td v-if="companyBenefit.dependentBenefit" class="text-right">
                                {{companyBenefit.dependentAnnualUsage.toFixed(2)}}
                            </td>
                        </tr>
                        <tr>
                            <td><b>Current Annual Balance (RM)</b></td>
                            <td :class="['text-right', {
                                'text-success': companyBenefit.companyAnnualUsagePercentage<=30,
                                'text-warning': companyBenefit.companyAnnualUsagePercentage>30 && companyBenefit.companyAnnualUsagePercentage<=70,
                                'text-danger': companyBenefit.companyAnnualUsagePercentage>70
                            }]"><b>
                                {{(companyBenefit.companyAnnualLimit - companyBenefit.companyAnnualUsage).toFixed(2)}}
                            </b></td>
                            <td v-if="companyBenefit.spouseBenefit" :class="['text-right', {
                                'text-success': companyBenefit.spouseAnnualUsagePercentage<=30,
                                'text-warning': companyBenefit.spouseAnnualUsagePercentage>30 && companyBenefit.spouseAnnualUsagePercentage<=70,
                                'text-danger': companyBenefit.spouseAnnualUsagePercentage>70
                            }]"><b>
                                {{(companyBenefit.spouseAnnualLimit - companyBenefit.spouseAnnualUsage).toFixed(2)}}
                            </b></td>
                            <td v-if="companyBenefit.dependentBenefit" :class="['text-right', {
                                'text-success': companyBenefit.dependentAnnualUsagePercentage<=30,
                                'text-warning': companyBenefit.dependentAnnualUsagePercentage>30 && companyBenefit.dependentAnnualUsagePercentage<=70,
                                'text-danger': companyBenefit.dependentAnnualUsagePercentage>70
                            }]"><b>
                                {{(companyBenefit.dependentAnnualLimit - companyBenefit.dependentAnnualUsage).toFixed(2)}}
                            </b></td>
                        </tr>
                        <tr>
                            <td><b>Total Annual Allowance (RM)</b></td>
                            <td class="text-right">
                                {{companyBenefit.companyAnnualLimit.toFixed(2)}}
                            </td>
                            <td v-if="companyBenefit.spouseBenefit" class="text-right">
                                {{companyBenefit.spouseAnnualLimit.toFixed(2)}}
                            </td>
                            <td v-if="companyBenefit.dependentBenefit" class="text-right">
                                {{companyBenefit.dependentAnnualLimit.toFixed(2)}}
                            </td>
                        </tr>
                        <template v-if="companyBenefit.companyMonthlyLimit > 0">
                            <tr>
                                <td><b>Monthly Aggregated Usage (RM)</b></td>
                                <td class="text-right">
                                    {{companyBenefit.companyMonthlyUsage.toFixed(2)}}
                                </td>
                                <td v-if="companyBenefit.spouseBenefit" class="text-right">
                                    {{companyBenefit.spouseMonthlyUsage.toFixed(2)}}
                                </td>
                                <td v-if="companyBenefit.dependentBenefit" class="text-right">
                                    {{companyBenefit.dependentMonthlyUsage.toFixed(2)}}
                                </td>
                            </tr>
                            <tr>
                                <td><b>Current Monthly Balance (RM)</b></td>
                                <td :class="['text-right', {
                                    'text-success': companyBenefit.companyMonthlyUsagePercentage<=30,
                                    'text-warning': companyBenefit.companyMonthlyUsagePercentage>30 && companyBenefit.companyMonthlyUsagePercentage<=70,
                                    'text-danger': companyBenefit.companyMonthlyUsagePercentage>70
                                }]"><b>
                                    {{(companyBenefit.companyMonthlyLimit - companyBenefit.companyMonthlyUsage).toFixed(2)}}
                                </b></td>
                                <td v-if="companyBenefit.spouseBenefit" :class="['text-right', {
                                    'text-success': companyBenefit.spouseMonthlyUsagePercentage<=30,
                                    'text-warning': companyBenefit.spouseMonthlyUsagePercentage>30 && companyBenefit.spouseMonthlyUsagePercentage<=70,
                                    'text-danger': companyBenefit.spouseMonthlyUsagePercentage>70
                                }]"><b>
                                    {{(companyBenefit.companyMonthlyLimit - companyBenefit.spouseMonthlyUsage).toFixed(2)}}
                                </b></td>
                                <td v-if="companyBenefit.dependentBenefit" :class="['text-right', {
                                    'text-success': companyBenefit.dependentMonthlyUsagePercentage<=30,
                                    'text-warning': companyBenefit.dependentMonthlyUsagePercentage>30 && companyBenefit.dependentMonthlyUsagePercentage<=70,
                                    'text-danger': companyBenefit.dependentMonthlyUsagePercentage>70
                                }]"><b>
                                    {{(companyBenefit.companyMonthlyLimit - companyBenefit.dependentMonthlyUsage).toFixed(2)}}
                                </b></td>
                            </tr>
                            <tr>
                                <td><b>Total Monthly Allowance (RM)</b></td>
                                <td class="text-right">
                                    {{companyBenefit.companyMonthlyLimit.toFixed(2)}}
                                </td>
                                <td v-if="companyBenefit.spouseBenefit" class="text-right">
                                    {{companyBenefit.companyMonthlyLimit.toFixed(2)}}
                                </td>
                                <td v-if="companyBenefit.dependentBenefit" class="text-right">
                                    {{companyBenefit.companyMonthlyLimit.toFixed(2)}}
                                </td>
                            </tr>
                        </template>
                        <template v-if="companyBenefit.companyWeeklyLimit > 0">
                            <tr>
                                <td><b>Weekly Aggregated Usage (RM)</b></td>
                                <td class="text-right">
                                    {{companyBenefit.companyWeeklyUsage.toFixed(2)}}
                                </td>
                                <td v-if="companyBenefit.spouseBenefit" class="text-right">
                                    {{companyBenefit.spouseWeeklyUsage.toFixed(2)}}
                                </td>
                                <td v-if="companyBenefit.dependentBenefit" class="text-right">
                                    {{companyBenefit.dependentWeeklyUsage.toFixed(2)}}
                                </td>
                            </tr>
                            <tr>
                                <td><b>Current Weekly Balance (RM)</b></td>
                                <td :class="['text-right', {
                                    'text-success': companyBenefit.companyWeeklyUsagePercentage<=30,
                                    'text-warning': companyBenefit.companyWeeklyUsagePercentage>30 && companyBenefit.companyWeeklyUsagePercentage<=70,
                                    'text-danger': companyBenefit.companyWeeklyUsagePercentage>70
                                }]"><b>
                                    {{(companyBenefit.companyWeeklyLimit - companyBenefit.companyWeeklyUsage).toFixed(2)}}
                                </b></td>
                                <td v-if="companyBenefit.spouseBenefit" :class="['text-right', {
                                    'text-success': companyBenefit.spouseWeeklyUsagePercentage<=30,
                                    'text-warning': companyBenefit.spouseWeeklyUsagePercentage>30 && companyBenefit.spouseWeeklyUsagePercentage<=70,
                                    'text-danger': companyBenefit.spouseWeeklyUsagePercentage>70
                                }]"><b>
                                    {{(companyBenefit.companyWeeklyLimit - companyBenefit.spouseWeeklyUsage).toFixed(2)}}
                                </b></td>
                                <td v-if="companyBenefit.dependentBenefit" :class="['text-right', {
                                    'text-success': companyBenefit.dependentWeeklyUsagePercentage<=30,
                                    'text-warning': companyBenefit.dependentWeeklyUsagePercentage>30 && companyBenefit.dependentWeeklyUsagePercentage<=70,
                                    'text-danger': companyBenefit.dependentWeeklyUsagePercentage>70
                                }]"><b>
                                    {{(companyBenefit.companyWeeklyLimit - companyBenefit.dependentWeeklyUsage).toFixed(2)}}
                                </b></td>
                            </tr>
                            <tr>
                                <td><b>Total Weekly Allowance (RM)</b></td>
                                <td class="text-right">
                                    {{companyBenefit.companyWeeklyLimit.toFixed(2)}}
                                </td>
                                <td v-if="companyBenefit.spouseBenefit" class="text-right">
                                    {{companyBenefit.companyWeeklyLimit.toFixed(2)}}
                                </td>
                                <td v-if="companyBenefit.dependentBenefit" class="text-right">
                                    {{companyBenefit.companyWeeklyLimit.toFixed(2)}}
                                </td>
                            </tr>
                        </template>
                        <tr v-if="companyBenefit.transactionLimit.teleconsultationApplicable">
                            <td><b>Tele-consultation Transaction Limit</b></td>
                            <td class="text-right">
                                {{companyBenefit.transactionLimit.teleconsultation}}
                            </td>
                        </tr>
                        <tr v-if="companyBenefit.transactionLimit.medicineApplicable">
                            <td><b>Medicine Transaction Limit (Telehealth Only)</b></td>
                            <td class="text-right">
                                {{companyBenefit.transactionLimit.medicine}}
                            </td>
                        </tr>
                        <tr v-if="companyBenefit.transactionLimit.clinicApplicable">
                            <td><b>Combined Limit for Clinic Consultation and Clinic Medicine</b></td>
                            <td class="text-right">
                                {{companyBenefit.transactionLimit.clinic}}
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="card">
                    <div class="card-body">
                        <small><b>Legends: Color Indicators of the Company Credit Remaining Amount</b></small>
                        <ul class="mb-0">
                            <li class="text-success">
                                <small>
                                    <b>
                                        Indicates balance of company credit more than 70% remaining
                                    </b>
                                </small>
                            </li>
                            <li class="text-warning">
                                <small>
                                    <b>
                                        Indicates balance of company credit between 30% and 70% remaining
                                    </b>
                                </small>
                            </li>
                            <li class="text-danger">
                                <small>
                                    <b>
                                        Indicates balance of company credit less than 30% remaining
                                    </b>
                                </small>
                            </li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>

        <div ref="tableSection">
            <h5 class="mb-3">Company Credit Balance History</h5>
            <table ref="listTable" class="table table-hover">
                <colgroup>
                    <col width="40">
                    <col width="200">
                    <col width="140">
                    <col>
                </colgroup>
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Action Date</th>
                        <th scope="col" class="text-right">Amount (RM)</th>
                        <th scope="col">Remarks</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-show="historyList.length === 0">
                        <td :colspan="columnsCount" class="text-center font-italic">
                            {{isTableLoading ? "Loading Data": "No Data"}}
                        </td>
                    </tr>
                    <tr v-for="(historyItem, index) in historyList" :key="index">
                        <th scope="row">{{((pagination.currentPage - 1) *pagination.pageSize ) + index + 1}}</th>
                        <td class="text-nowrap">{{historyItem.date}}</td>
                        <td class="text-nowrap text-right">
                            {{historyItem.amount}}
                        </td>
                        <td class="text-nowrap">
                            <span :class="'badge badge-pill ' + getTagClass(historyItem.tag)">{{historyItem.tag}}</span> {{historyItem.remarks}}
                        </td>
                    </tr>
                </tbody>
            </table>
            <pagination v-model="pagination.currentPage"
                :totalPages="pagination.totalPages"
                :scrollPosition="pagination.scrollPosition">
            </pagination>
        </div>

        <popup-modal ref="popupModalCoverage" :hasCloseButton="true" :title="'Benefits Coverage'">
            <template slot="content">
                <permissible v-model="permissibles" :isFullBenefits="isFullBenefits" :viewOnly="true" :uniqueIdentifier="1"></permissible>
            </template>
            <template slot="footer">
                <div>
                    <button class="btn btn-secondary" type="button" @click="$refs.popupModalCoverage.hide()">Close</button>
                </div>
            </template>
        </popup-modal>
    </div>
</template>

<script>
import pagination from '@/components/pagination';
import {
    convertToUserReadableDateTime
} from '@/utilities';
import popupModal from '@/components/popup-modal';
import permissible from '@/components/permissible';
export default {
    'name': 'UserWallet',
    'components': {
        pagination,
        popupModal,
        permissible
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;
        this.getMyCompanyBalance();
        this.getWalletLog();

        // initialize scroll position
        this.$nextTick(() => {
            this.pagination.scrollPosition = this.$refs.tableSection.getBoundingClientRect().top + window.scrollY - document.querySelector('.top-navigation').clientHeight;
        });
    },
    'computed': {
        currentPage () {
            return this.pagination.currentPage;
        }
    },
    'watch': {
        currentPage () {
            this.$nextTick(() => {
                this.getWalletLog();
            });
        }
    },
    data () {
        return {
            'companyCreditUsage': 0,
            'companyAnnualLimit': 0,
            'historyList': [],
            'columnsCount': 1,
            'isTableLoading': true,
            'pagination': {
                'currentPage': 1,
                'totalPages': 0,
                'pageSize': 20,
                'scrollPosition': 0
            },
            'transactionLimit': {
                'teleconsultation': '',
                'teleconsultationApplicable': false,
                'medicine': '',
                'medicineApplicable': false,
                'clinic': '',
                'clinicApplicable': false
            },
            'companyBenefits': [],
            'permissibles': [],
            'isFullBenefits': false
        };
    },
    'methods': {
        getMyCompanyBalance () {
            this.axios.get('CompanyCredit/GetMyCompanyBalance').then(({
                data
            }) => {
                this.companyBenefits = data.data.map((item) => ({
                    'companyName': item.cn,
                    'principalName': item.pn,
                    'benefitType': item.bt,
                    'companyAnnualLimit': item.al,
                    'companyMonthlyLimit': item.ml,
                    'companyWeeklyLimit': item.wl,
                    'companyAnnualUsage': item.au,
                    'companyAnnualUsagePercentage': item.au / item.al * 100,
                    'companyMonthlyUsage': item.mu,
                    'companyMonthlyUsagePercentage': item.mu / item.ml * 100,
                    'companyWeeklyUsage': item.wu,
                    'companyWeeklyUsagePercentage': item.wu / item.wl * 100,
                    'spouseBenefit': item.sb,
                    'spouseAnnualLimit': item.sal,
                    'spouseAnnualUsage': item.sau,
                    'spouseAnnualUsagePercentage': item.sau / item.sal * 100,
                    'spouseMonthlyUsage': item.smu,
                    'spouseMonthlyUsagePercentage': item.smu / item.ml * 100,
                    'spouseWeeklyUsage': item.swu,
                    'spouseWeeklyUsagePercentage': item.swu / item.wl * 100,
                    'dependentBenefit': item.db,
                    'dependentAnnualLimit': item.dal,
                    'dependentAnnualUsage': item.dau,
                    'dependentAnnualUsagePercentage': item.dau / item.dal * 100,
                    'dependentMonthlyUsage': item.dmu,
                    'dependentMonthlyUsagePercentage': item.dmu / item.ml * 100,
                    'dependentWeeklyUsage': item.dwu,
                    'dependentWeeklyUsagePercentage': item.dwu / item.wl * 100,
                    'transactionLimit': {
                        'teleconsultation': item.hctl ? `RM ${item.ectl.toFixed(2)}` : 'N/A',
                        'teleconsultationApplicable': item.hctl ? item.ectl > 0 : false, // do not display if company set the limit to 0
                        'medicine': item.hptl ? `RM ${item.eptl.toFixed(2)}` : 'N/A',
                        'medicineApplicable': item.hptl ? item.eptl > 0 : false, // do not display if company set the limit to 0
                        'clinic': item.hcctl ? `RM ${item.ecctl.toFixed(2)}` : 'N/A',
                        'clinicApplicable': item.hcctl ? item.ecctl > 0 : false // do not display if company set the limit to 0
                    },
                    'isFullBenefits': item.ifb,
                    'permissibles': item.p
                }));
            });
            this.companyBenefits.push();
        },
        getWalletLog () {
            this.axios.post('CompanyCredit/GetMySpendings', {
                'p': this.pagination.currentPage,
                'ps': this.pagination.pageSize
            }).then(({
                data
            }) => {
                this.isTableLoading = false;
                let pagedResult = data.data;

                this.pagination.currentPage = pagedResult.p;
                this.pagination.totalPages = pagedResult.c;

                let list = pagedResult.l;
                this.historyList = list.map((item) => ({
                    'amount': `${item.a.toFixed(2)}`,
                    'date': item.d ? convertToUserReadableDateTime(item.d) : '-',
                    'remarks': item.r ? item.r : '-',
                    'tag': item.t
                }));
            });
        },
        getTagClass (tag) {
            switch (tag) {
            case 'Self':
                return 'badge-success';
            case 'Spouse':
                return 'badge-info';
            case 'Dependent':
                return 'badge-secondary';
            default:
                return 'badge-primary';
            }
        },
        openCoverage (index) {
            this.permissibles = this.companyBenefits[index].permissibles;
            this.isFullBenefits = this.companyBenefits[index].isFullBenefits;
            this.$refs.popupModalCoverage.show();
        }
    }
};

</script>

<style>
    .ewallet-display:not(:last-child) {
        padding: 0 0 1.25rem;
    }

    .ewallet-display {
        font-size: 2rem;
        font-weight: 300;
    }

</style>
